const V1 = "/api/v1";

/** Versioned + platform API paths — keep in sync with `src/app/api/`. */
export const Api_Paths = {
  Health: "/api/health",

  V1: {
    Info: `${V1}/info`,

    Auth: {
      Signup: `${V1}/auth/signup`,
      Signup_Send_Code: `${V1}/auth/signup/send-code`,
      Login: `${V1}/auth/login`,
      Refresh: `${V1}/auth/refresh`,
      Signout: `${V1}/auth/signout`,
    },

    User_Me: `${V1}/user/me`,
    User_Password: `${V1}/user/password`,
    Credits: `${V1}/credits`,
    Admin_Status: `${V1}/admin/status`,
    Public_Time: `${V1}/public/time`,

    Parcel: {
      By_Apn: `${V1}/parcel/by-apn`,
      By_Address: `${V1}/parcel/by-address`,
    },

    Amenities: {
      List: `${V1}/amenities`,
      Barrier_Flags: `${V1}/amenities/barrier-flags`,
      Export: `${V1}/amenities/export`,
    },

    Payments: {
      Config: `${V1}/payments/config`,
      Checkout: `${V1}/payments/checkout`,
      Confirm: `${V1}/payments/confirm`,
      Webhook: `${V1}/payments/webhook`,
    },

    Reports: {
      Generate: `${V1}/reports/generate`,
      Stats: `${V1}/reports/stats`,
      Availability: `${V1}/reports/availability`,
      Job: (Job_Id: string) => `${V1}/reports/jobs/${encodeURIComponent(Job_Id)}`,
      Job_Console_Log: (Job_Id: string) => `${V1}/reports/jobs/${encodeURIComponent(Job_Id)}/console-log`,
      Booklet: (Job_Id: string) => `${V1}/reports/booklet/${encodeURIComponent(Job_Id)}`,
      Download: (Report_Type: string, Apn: string) =>
        `${V1}/reports/download/${encodeURIComponent(Report_Type)}/${encodeURIComponent(Apn)}`,
    },
  },
} as const;
